<template>
  <div
    class="web_top_az"
    :class="$t('languages') == 'EN' ? 'web_top_az_en' : ''"
  >
    <img :src="$t('azabordData.topImg1')" alt="" />
    <div class="top_det">
      <div class="clf100 font46 font700w clw100 wel_top">WELCOME!</div>
      <div class="clb100 font46">
        {{ $t("AaAbordTop." + $route.query.prev + "Title") }}
      </div>
      <div
        :class="$route.query.prev == 'az' ? 'font18' : 'font18'"
        class="clb100 det_det"
      >
        {{ $t("AaAbordTop." + $route.query.prev + "Det") }}
      </div>
    </div>
    <div class="bot_btn">
      <div class="font16 det_btn clf100" @click="goApply(1)">
        {{ $t("AaAbordTop." + $route.query.prev + "Btn1") }}
      </div>
      <div
        v-if="$route.query.prev != 'az'"
        class="font16 det_btn btn_mr clf100"
        @click="goApply(2)"
      >
        {{ $t("AaAbordTop." + $route.query.prev + "Btn2") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goApply(index) {
      if (
        !localStorage.getItem("AZG_TOKEN") ||
        localStorage.getItem("AZG_TOKEN") === null
      ) {
        this.$router.push("/login");
        return;
      }
      let applyQuery = this.$t(
        "AaAbordTop." + this.$route.query.prev + "applyQueryBtn" + index
      );
      this.$emit("goApply", applyQuery);
    }
  }
};
</script>

<style lang="less" scoped>
.web_top_az {
  position: relative;
  width: 100%;
  height: calc(100vw * 46.2 / 192);
  text-align: left;
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  .wel_top {
    margin-bottom: calc(100vw * 2.4 / 192);
  }
  .top_det {
    position: absolute;
    left: calc(100vw * 26 / 192);
    right: calc(100vw * 26 / 192);
    top: calc(100vw * 3.6 / 192);
    z-index: 99;
  }
  .det_det {
    margin-top: calc(100vw * 1 / 192);
    // line-height: calc(100vw * 2.8 / 192);
  }
  .bot_btn {
    position: absolute;
    left: calc(100vw * 26 / 192);
    bottom: calc(100vw * 3 / 192);
    display: flex;
  }
  .det_btn {
    // background: #fff;
    background: #bf9264;
    display: inline-block;
    padding: calc(100vw * 1 / 192) calc(100vw * 6 / 192);
    border-radius: 4px;
    margin-top: calc(100vw * 1.1 / 192);
    cursor: pointer;
  }
  .btn_mr {
    margin-left: calc(100vw * 2.4 / 192);
  }
}
.web_top_az_en {
  height: calc(100vw * 55.2 / 192);
  .top_det {
    left: calc(100vw * 25 / 192);
    right: calc(100vw * 25 / 192);
  }
}
</style>
